export default {
  PAGE_WIZARD: 'page-wizard',
  REGENERATE_BLOCK: 'regenerate-block',
  AI_ONBOARDING: 'ai-onboarding',
  SITE_WIZARD: 'site-wizard',
};
